import React, { useState, useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {withRouter} from 'react-router-dom'
// import Fade from 'react-reveal/Fade'
import FormAction from './formAction'
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function ApplicantInfo (props){

  const [startDate, setStartDate] = useState(new Date());
  const [state, setState] = useState({
    formData: {
      percent_completed: 10,
      first_name: '',
      preferred_name: '',
      middle_name: '',
      last_name: '',
      // maiden_name: '',
      date: '',
      month: '',
      year: ''
    },
    first_nameValid: false,
    last_nameValid: false,
    monthValid: true,
    dateValid: true,
    yearValid: true,
    isFormDataValid: false
  })

  const { savedSteps, selectedProgramId, selectedProgramLabel } = useSelector((state) => ({
    savedSteps: state.applicationReducer.savedSteps,
    selectedProgramId: state.applicationReducer.selectedProgramId,
    selectedProgramLabel: state.applicationReducer.selectedProgramLabel
  }), shallowEqual);
    
    
  useEffect(()=>{
    window.scrollTo(0, 0)
    setStartDate(null);
    if (!!savedSteps.applicantInfo) {
      populateForm();
    } else if (!!savedSteps.loggedOutUserInfo && !savedSteps.applicantInfo){
      prePopulateForm();
    } else {
      iterateDate(startDate);
    }
  },[])

  useEffect(()=>{
    validateForm();
  },[state])

  function prePopulateForm() {
    const loggedOutData = savedSteps.loggedOutUserInfo;
    if (Object.keys(loggedOutData).length > 0) {
      updateForm('first_name', loggedOutData.first_name)
      updateForm('last_name', loggedOutData.last_name)
    }
  }

  function populateForm(){
    const applicantInfoData = savedSteps.applicantInfo;
    if (!!savedSteps.applicantInfo && Object.keys(applicantInfoData).length > 0) {
      updateForm('preferred_name', applicantInfoData.preferred_name)
      updateForm('first_name', applicantInfoData.first_name)
      updateForm('middle_name', applicantInfoData.middle_name)
      updateForm('last_name', applicantInfoData.last_name)
      // updateForm('maiden_name', applicantInfoData.maiden_name)
      const month = applicantInfoData.month && (applicantInfoData.month < 1 || applicantInfoData.month > 12) ? 1 : applicantInfoData.month;
      const date = applicantInfoData.date && (applicantInfoData.date < 1 || applicantInfoData.date > 31) ? 1 : applicantInfoData.date;
      updateForm('month', month)
      updateForm('date', date)
      updateForm('year', applicantInfoData.year)
      if(!!applicantInfoData.date && applicantInfoData.month && applicantInfoData.year) {
        setStartDate(new Date(formatDate(applicantInfoData.month,applicantInfoData.date,applicantInfoData.year)))
      }
    }
  }

  const formatDate = (mon, date, year) => {
    return mon + '/' + date + '/' + year;
  }
  const updateForm = (field, value) => {
    let temp = state.formData
    temp[field] = value
    setState(prevState => ({ ...prevState, formData: temp }));
    _validate(field)
  }
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch(field){
      case 'preferred_name': 
      // case 'maiden_name':
        valid = true;
        break;
      case 'first_name': case 'middle_name' : case 'last_name': 
        regex = /^.{2,}/;
        valid = regex.test(value)
        break;
      case 'date':
        valid = (value == 2) ? (value > 0 && value <= 29) : (value > 0 && value <= 31);
        break;
      case 'month':
        valid = value > 0 && value <= 12
        break;
      case 'year':
        let year = new Date().getFullYear();
        valid = (state.formData.date == 29 && state.formData.month == 2) ? (value > 1900 && value <= year && value % 4 == 0) : (value > 1900 && value <= year)
        break;
    }
    setState(prevState => ({ ...prevState, [field+"Valid"]: valid }));
  }

  const validateForm = () => {
    let formData = state
    let form = !!formData.first_nameValid && !!formData.last_nameValid && !!formData.monthValid && !!formData.dateValid && !!formData.yearValid
    if (state.isFormDataValid != form) {
      setState(prevState => ({ ...prevState, isFormDataValid: form }));
    }
  }

  const iterateDate = (dateObj) => {
    if(dateObj){
      const month = dateObj ? dateObj.getMonth() + 1 : null; //months from 1-12
      const date =  dateObj ? dateObj.getDate() > 31 ? 31 : dateObj.getDate() : null;
      const year =  dateObj ? dateObj.getFullYear()  : null;
      updateForm('month', month)
      updateForm('date', date)
      updateForm('year', year)
      setStartDate(dateObj);
    } else {
      setStartDate(null);
    }
  }

  const setMinDate = () => {
    let date = new Date();
    // date = date.setFullYear(date.getFullYear()-50);
    date = new Date(1950, 1, 1);
    return date;
  }

  const setMaxDate = () => {
    const date = new Date();
    return date.setFullYear(date.getFullYear()-16)
  }

  return(
    <>
      <div className="app-form-container">
      		<div className="main-heading bayan-main-heading">
            {selectedProgramLabel}
          </div>
          <div className="sub-heading app-info">
            Applicant Information
          </div>

          <div className="input-group">
            <div className="field-label">First Name</div>
            <input type='text' className={(state.first_nameValid === false) ? 'error' : ''} value={state.formData.first_name} placeholder='Enter Name' onChange={(e)=>{updateForm('first_name', e.target.value)}} />
            {(state.first_nameValid === false) && <div className="field-error">Must enter first name.</div>}
          </div>
          <div className="input-group">
            <div className="field-label">Preferred Name (optional)</div>
            <input type='text' value={state.formData.preferred_name} placeholder='Enter Name' onChange={(e)=>{updateForm('preferred_name', e.target.value)}} />
          </div>
          <div className="input-group">
            <div className="field-label">Middle Name(Optional)</div>
            <input type='text'className="" value={state.formData.middle_name} placeholder='Enter Middle Name' onChange={(e)=>{updateForm('middle_name', e.target.value)}}/>
          </div>
          <div className="input-group">
            <div className="field-label">Last Name</div>
            <input type='text' className={state.last_nameValid  === false ? 'error' : ''} value={state.formData.last_name} placeholder='Enter Last Name' onChange={(e)=>{updateForm('last_name', e.target.value)}}/>
            {state.last_nameValid  === false && <div className="field-error">Must enter last name.</div>}
          </div>

          {/* <div className="input-group">
            <div className="field-label">Maiden Name</div>
            <input type='text' value={state.formData.maiden_name} placeholder='Enter Maiden Name' onChange={(e)=>{updateForm('maiden_name', e.target.value)}}/>
          </div> */}

          <div className="input-group">
            <div className="field-label">Date of Birth</div>
            {/* <input type='number' className={state.monthValid === false ? 'error select-date' : 'select-date'} value={state.formData.month} placeholder='Month' onChange={(e)=>{updateForm('month', e.target.value)}} />
            <input type='number' className={state.dateValid === false ? 'error select-date' : 'select-date'} value={state.formData.date} placeholder='Date' onChange={(e)=>{updateForm('date', e.target.value)}} />
            <input type='number' className={state.yearValid === false ? 'error select-date' : 'select-date'} value={state.formData.year} placeholder='Year' onChange={(e)=>{updateForm('year', e.target.value)}} /> */}
            <Datepicker
              selected={startDate}
              onChange={date => iterateDate(date)}
              showDateDropdown
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              dateFormat='MM/dd/yyyy'
              minDate={setMinDate()}
              maxDate={setMaxDate()}
              isClearable={true}
              // placeholder="MM/DD/YYYY"
              placeholderText="MM/DD/YYYY"
            />
              {state.monthValid === false && <div className="field-error">Must select month.</div>}
              {state.dateValid === false && <div className="field-error">Must select date.</div>}
              {state.yearValid === false && <div className="field-error">Invalid Date</div>}
          </div>

          <FormAction 
            isFormDataValid={state.isFormDataValid}
            formData={state.formData}
            formStep={'applicantInfo'}
            backStep={''}
            nextStep={'contactInfo'}
          />
      	</div>
    </>
    );
  }

export default ApplicantInfo;
